import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
} from '@mui/material'
import React from 'react'

import { AddDistrictPackages } from './AddDistrictPackages'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FeaturePackageConfirm } from '../../shared/FeaturePackageConfirm'
import { FeaturesPackagesList } from '../../shared/FeaturesPackagesList'
import { SchoolFeaturesSection } from './SchoolFeaturesSection'
import { packageListStringFromFeatures } from '../../../utility/utils'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import {
  districtResponseAtom,
  districtSchoolsAtomWithRefresh,
} from 'shared/api/district'
import {
  selectedActionAtom,
  selectedFeaturePackageAtom,
} from 'shared/api/platformFeatures'

export default function DistrictFeatures() {
  const [district, reFetchDistrict] = useAtom(districtResponseAtom)
  const [schools, refetchSchools] = useAtom(districtSchoolsAtomWithRefresh)
  const setSelectedAction = useSetAtom(selectedActionAtom)
  const setSelectedPackageName = useSetAtom(selectedFeaturePackageAtom)

  const closeDialog = () => {
    reFetchDistrict()
    refetchSchools()
  }

  const removeDistrictPackageButton = (packageName: string) => {
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          setSelectedAction({ actionType: 'remove', entityType: 'district' })
          setSelectedPackageName(packageName)
        }}
      >
        Remove from district
      </Button>
    )
  }

  const packageList = packageListStringFromFeatures(district?.features ?? [])

  return (
    <>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          District feature packages
          {packageList.length !== 0 && ' ( ' + packageList + ' )'}
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ flexGrow: 1 }}>
            <Box>
              {district?.features.length ? (
                <FeaturesPackagesList
                  platformFeatures={district.features}
                  childrenForFeaturePackage={removeDistrictPackageButton}
                />
              ) : (
                <Box sx={{ p: 2 }}>
                  <b>There are no district feature packages available</b>
                </Box>
              )}
            </Box>
            <AddDistrictPackages />
            <hr />
            <SchoolFeaturesSection schools={schools} />
          </Box>
        </AccordionDetails>
      </Accordion>
      <FeaturePackageConfirm onCloseDialog={closeDialog} />
    </>
  )
}
